import React from "react";
import { Col, Row } from "antd";
import { convertToRGBAString } from "utils/helperFunctions";
import { useSelector } from "react-redux";
import { fontSize } from "utils/CONSTANTS";

const ComponentTitle = React.memo(({ component }) => {
  const selectedLanguage = useSelector((state) => state.selectedLanguage);

  return (
    component.is_component_title && (
      <Row justify="center">
        <Col
          className="font-helvetica-neue-medium"
          style={{
            fontSize: fontSize[component.component_title_size],
            color: convertToRGBAString(component.component_title_text_color),
            backgroundColor: convertToRGBAString(
              component.component_title_bg_color
            ),
            padding: "1vh",
            borderRadius: 8,
            textAlign: "center",
            marginTop: 20,
            maxWidth: "85%",
          }}
        >
          <p className="component_title">
            {component.component_title[selectedLanguage]}
            {/* Please share your experience with us to help us on improvements */}
          </p>
        </Col>
      </Row>
    )
  );
});

export default ComponentTitle;
